import { render, staticRenderFns } from "./HotelBuildingEditView.vue?vue&type=template&id=0df64a22&"
import script from "./HotelBuildingEditView.vue?vue&type=script&lang=js&"
export * from "./HotelBuildingEditView.vue?vue&type=script&lang=js&"
import style0 from "./HotelBuildingEditView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports